<template>
  <div class="auth flex flexaj">
    <div class="left flexc">
      <div class="h30 mb20 flexend" style="text-align:right;">參照編號</div>
      <div class="h30 mb20 flexend" v-if="type==='entity'&&status!=='2'">請輸入任意一張卡片的激活碼</div>
      <div class="h30 mb20 flexend">購買時填寫手機號碼</div>
      <div class="h30 mb20 flexend">動態驗證碼</div>
    </div>
    <div class="right flexc">
      <div class="h30 mb20">{{order_no}}</div>
      <el-input v-model="activateCode" class="mb20" v-if="type==='entity'&&status!=='2'"></el-input>
      <div class="flexa">
        <div class="flexa mb20">
          <el-select v-model="mobileCodeSelected" placeholder="請選擇" style="width:160px;">
            <el-option
              v-for="item in mobileCode"
              :key="item.value"
              :label="item.code+'  '+item.area"
              :value="item.code"
            ></el-option>
          </el-select>
          <el-input v-model="mobile" style="width:200px;margin-left: 10px;" maxlength="11"></el-input>
        </div>
      </div>
      <div class="flexa">
        <el-input v-model="captcha" style="width: 200px;"></el-input>
        <div class="getSMSCode" @click="getSMSCode" v-if="!isCounting">獲取驗證碼</div>
        <div class="p-999" style="margin-left: 16px;" v-else>{{count}}s後重新獲取</div>
      </div>
      <!-- <div class="p-f14 p-999" style="margin-top:20px;">已發送到135****3119請註意查收</div> -->
      <el-button
        type="primary"
        class="p-fw"
        style="width:100px; margin-top: 20px;"
        @click="activate"
        :loading="isLoading"
      >查看</el-button>
    </div>
  </div>
</template>

<script>
import { aPost2 } from "@/utils/request";
import api from "@/utils/api";
import { mobileCode } from "../assets/mobileCode.json";
import { getUrlValue, fakeMobile } from "@/utils/fun";
export default {
  data() {
    return {
      isLoading: false,
      status: 0,
      activateCode: "",
      captcha: "",
      type: "",
      mobile: "",
      mobileCodeSelected: "86",
      mobileCode: [],
      order_no: "",
      clock: null,
      count: 60,
      isCounting: false
    };
  },
  methods: {
    //倒計時
    startCounting() {
      this.count = 60;
      let that = this;
      that.isCounting = true;
      that.clock = setInterval(() => {
        if (that.count > 0) {
          that.count--;
        } else {
          clearInterval(that.clock);
          that.clock = null;
          that.isCounting = false;
        }
      }, 1000);
    },

    //獲取驗證碼
    async getSMSCode() {
      let params = {
        type: 88,
        phone:
          this.mobileCodeSelected === "86"
            ? this.mobile
            : this.mobileCodeSelected + "-" + this.mobile,
        email: this.email,
        gf_order_no: this.order_no
      };
      let res = await aPost2(api.getSMSCode, params);
      if (res.data.errCode === "99999") {
        this.startCounting();
      } else if (res.data.errCode === "100810") {
        this.$notify.error("操作過於頻繁，請稍後重試");
      } else {
        this.$notify({
          title: "錯誤",
          message: res.data.errMsg,
          type: "error"
        });
      }
    },
    async entityActivate() {
      if (!this.activateCode && this.status !== "2") {
        this.$notify({
          title: "警告",
          message: "激活碼不能為空",
          type: "error"
        });
        return false;
      }
      if (!this.mobileCodeSelected) {
        this.$notify({
          title: "警告",
          message: "請選擇區號",
          type: "error"
        });
        return false;
      }
      if (!this.mobile) {
        this.$notify({
          title: "警告",
          message: "手機號碼不能為空",
          type: "error"
        });
        return false;
      }
      if (!this.captcha) {
        this.$notify({
          title: "警告",
          message: "驗證碼不能為空",
          type: "error"
        });
        return false;
      }
      let params = {
        order_no: this.order_no,
        active_code: this.activateCode,
        mob_no: this.mobile,
        verify_code: this.captcha
      };
      this.isLoading = true;
      let res = await aPost2(api.cardActivate, params);
      if (res.data.errCode === "99999") {
        sessionStorage.setItem("order_no", this.order_no);
        this.$router.push({
          name: "inquire",
          params: { order_no: this.order_no, type: this.type }
        });
      } else {
        this.isLoading = false;
        this.$notify({
          title: "錯誤",
          message: `${res.data.errMsg}`,
          type: "error"
        });
      }
    },
    async virtualActivate() {
      if (!this.mobileCodeSelected) {
        this.$notify({
          title: "警告",
          message: "請選擇區號",
          type: "error"
        });
        return false;
      }
      if (!this.mobile) {
        this.$notify({
          title: "警告",
          message: "手機號碼不能為空",
          type: "error"
        });
        return false;
      }
      if (!this.captcha) {
        this.$notify({
          title: "警告",
          message: "驗證碼不能為空",
          type: "error"
        });
        return false;
      }
      let params = {
        order_no: this.order_no,
        mob_no: this.mobile,
        verify_code: this.captcha
      };
      this.isLoading = true;
      let res = await aPost2(api.cardActivate, params);
      if (res.data.errCode === "99999") {
        sessionStorage.setItem("order_no", this.order_no);
        this.$router.push({
          name: "inquire",
          params: { order_no: this.order_no, type: this.type }
        });
      } else if (res.data.errCode === "88888") {
        this.isLoading = false;
        this.$notify({
          title: "錯誤",
          message: `${res.data.errMsg}`,
          type: "error"
        });
        clearInterval(this.clock);
        this.clock = null;
        this.isCounting = false;
      } else {
        this.isLoading = false;
        this.$notify({
          title: "錯誤",
          message: `${res.data.errMsg}`,
          type: "error"
        });
      }
    },
    async activate() {
      if (this.type === "entity") {
        this.entityActivate();
      } else {
        this.virtualActivate();
      }
    },
    async getOrderStatus() {
      let res = await aPost2(api.queryStatus, { order_no: this.order_no });
      if (res.data.errCode === "99999") {
        this.status = res.data.retData.status;
        this.type = res.data.retData.card_type === "00" ? "entity" : "virtual";
        // if (this.status === "2") {
        //   sessionStorage.setItem("order_no", this.order_no);
        //   this.$router.push({
        //     name: "inquire",
        //     params: { order_no: this.order_no, type: this.type }
        //   });
        // }
      }
    }
  },
  mounted() {
    this.isLoading = false;
    this.mobileCode = mobileCode;
    if (getUrlValue("order_no") || sessionStorage.getItem("order_no")) {
      this.order_no =
        getUrlValue("order_no") || sessionStorage.getItem("order_no");
      this.getOrderStatus();
    } else {
      this.$message.error({
        message: "訂單號丟失，請重新打開此頁面！",
        duration: 0
      });
    }
    // this.getOrderStatus();
  }
};
</script>

<style lang="scss" scoped>
.auth {
  width: 960px;
  margin: 40px auto 80px;
  padding: 40px 0;
  border: 1px solid #ccc;
  border-radius: 4px;
  .left {
    position: relative;
    top: -20px;
    /* height: 450px; */
    padding-right: 40px;
    margin-left: -80px;
  }
  .right {
    /* height: 450px; */
  }
  .mb20 {
    margin-bottom: 20px;
  }
  .h30 {
    display: flex;
    align-items: center;
    height: 36px;
  }
  /deep/ .el-input__inner {
    height: 36px;
  }

  .getSMSCode {
    padding: 6px 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    margin-left: 10px;
    cursor: pointer;
  }
}
</style>
